import { LayoutDashboard, Boxes, Building2, Truck, ClipboardList, BarChart3, History, PackageCheck, BookOpen } from "lucide-react";

export const nav = [
  { id: "dashboard", label: "Overview", icon: LayoutDashboard },
  { id: "inventory", label: "Inventory", icon: Boxes },
  { id: "vendors", label: "Vendors", icon: Truck },
  { id: "departments", label: "Departments", icon: Building2 },
  { id: "indents", label: "Department indents", icon: ClipboardList },
  { id: "receiving", label: "Receiving", icon: PackageCheck },
  { id: "ledger", label: "Vendor ledger", icon: BookOpen },
  { id: "analytics", label: "Analytics", icon: BarChart3 },
  { id: "audit", label: "Audit history", icon: History },
];

export const RESOURCE_KEYS = ["inventory", "vendors", "departments", "indents", "receiving"];
